import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlotArea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 27 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.31407 22.3163C1.57225 22.5744 1.57217 22.993 1.31399 23.2512C1.05582 23.5094 0.637308 23.5094 0.379132 23.2512C0.120955 22.993 0.120875 22.5744 0.379051 22.3163C0.637228 22.0581 1.0559 22.0581 1.31407 22.3163Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.3135 18.5764C1.57168 18.8346 1.57176 19.2532 1.31358 19.5114C1.05541 19.7696 0.63674 19.7696 0.378563 19.5114C0.120387 19.2532 0.120467 18.8346 0.378643 18.5764C0.63682 18.3183 1.05533 18.3183 1.3135 18.5764Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.31342 14.8368C1.5716 15.0949 1.5716 15.5135 1.31342 15.7716C1.05525 16.0298 0.63674 16.0298 0.378563 15.7716C0.120387 15.5135 0.120387 15.0949 0.378563 14.8368C0.63674 14.5786 1.05525 14.5786 1.31342 14.8368Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.31358 11.097C1.57176 11.3552 1.57168 11.7738 1.3135 12.032C1.05533 12.2901 0.63682 12.2901 0.378644 12.032C0.120467 11.7738 0.120387 11.3552 0.378563 11.097C0.63674 10.8388 1.05541 10.8388 1.31358 11.097Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.3135 7.3572C1.57168 7.61537 1.57176 8.03396 1.31358 8.29214C1.05541 8.55031 0.63674 8.55031 0.378563 8.29214C0.120387 8.03396 0.120467 7.61537 0.378643 7.3572C0.63682 7.09902 1.05533 7.09902 1.3135 7.3572",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.31342 3.61802C1.5716 3.8762 1.5716 4.2947 1.31342 4.55288C1.05525 4.81106 0.63674 4.81106 0.378563 4.55288C0.120387 4.2947 0.120386 3.8762 0.378563 3.61802C0.636739 3.35984 1.05525 3.35984 1.31342 3.61802Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.34004 0.46714C1.59821 0.725316 1.59821 1.14382 1.34003 1.402C1.08186 1.66018 0.663351 1.66018 0.405175 1.402C0.146998 1.14382 0.146997 0.725317 0.405174 0.467141C0.66335 0.208964 1.08186 0.208963 1.34004 0.46714Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_416_8020)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M5.66274 1C4.74457 1 4.00024 1.74433 4.00024 2.6625V18.3375C4.00024 19.2557 4.74457 20 5.66274 20H21.3377C22.2559 20 23.0002 19.2557 23.0002 18.3375V2.6625C23.0002 1.74433 22.2559 1 21.3377 1H5.66274ZM5.42524 2.6625C5.42524 2.53133 5.53158 2.425 5.66274 2.425H21.3377C21.4689 2.425 21.5752 2.53133 21.5752 2.6625V18.3375C21.5752 18.4687 21.4689 18.575 21.3377 18.575H5.66274C5.53158 18.575 5.42524 18.4687 5.42524 18.3375V2.6625Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.31484 23.1944C1.05667 23.4526 0.638078 23.4525 0.379901 23.1944C0.121725 22.9362 0.121725 22.5177 0.379902 22.2595C0.638078 22.0013 1.05667 22.0012 1.31484 22.2594C1.57302 22.5176 1.57302 22.9363 1.31484 23.1944Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.05467 23.1944C4.79649 23.4525 4.3779 23.4526 4.11973 23.1944C3.86155 22.9363 3.86155 22.5176 4.11973 22.2594C4.3779 22.0012 4.79649 22.0013 5.05467 22.2595C5.31285 22.5177 5.31285 22.9362 5.05467 23.1944Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.79409 23.1943C8.53591 23.4525 8.11741 23.4525 7.85923 23.1943C7.60105 22.9361 7.60105 22.5176 7.85923 22.2594C8.11741 22.0012 8.53591 22.0012 8.79409 22.2594C9.05227 22.5176 9.05227 22.9361 8.79409 23.1943Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.5338 23.1944C12.2757 23.4526 11.8571 23.4525 11.5989 23.1944C11.3407 22.9362 11.3407 22.5177 11.5989 22.2595C11.8571 22.0013 12.2757 22.0012 12.5338 22.2594C12.792 22.5176 12.792 22.9363 12.5338 23.1944Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.2737 23.1944C16.0155 23.4525 15.5969 23.4526 15.3387 23.1944C15.0805 22.9363 15.0805 22.5176 15.3387 22.2594C15.5969 22.0012 16.0155 22.0013 16.2737 22.2595C16.5318 22.5177 16.5318 22.9362 16.2737 23.1944",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.0131 23.1943C19.7549 23.4525 19.3364 23.4525 19.0782 23.1943C18.82 22.9361 18.82 22.5176 19.0782 22.2594C19.3364 22.0012 19.7549 22.0012 20.0131 22.2594C20.2713 22.5176 20.2713 22.9361 20.0131 23.1943Z",
					fill: "var(--colors-grey-1)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.7536 23.1821C23.4954 23.4403 23.0769 23.4402 22.8187 23.1821C22.5605 22.9239 22.5605 22.5054 22.8187 22.2472C23.0769 21.989 23.4954 21.989 23.7536 22.2472C24.0117 22.5054 24.0117 22.9239 23.7536 23.1821Z",
					fill: "var(--colors-grey-1)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_416_8020",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26.8958,
				height: 26.8958,
				fill: "white",
				transform: "translate(0.104492)"
			})
		}) })
	]
});
export default SvgPlotArea;
